import { Icon, Props } from "./CheckmarkIcon.Parts";

export const CheckmarkIcon = ({ size = "large" }: Props) => (
  <Icon
    $size={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 9"
  >
    <path
      d="M3.12789 8.20771L0.0920941 5.17191C-0.030698 5.04912 -0.030698 4.8495 0.0920941 4.72671L1.42769 3.39111C1.55049 3.26832 1.7501 3.26832 1.87289 3.39111L3.12789 4.64611C3.25068 4.7689 3.4503 4.7689 3.57309 4.64611L8.1271 0.0920941C8.2499 -0.030698 8.44951 -0.030698 8.57231 0.0920941L9.9079 1.42769C10.0307 1.55049 10.0307 1.7501 9.9079 1.87289L3.57309 8.20771C3.4503 8.3305 3.25068 8.3305 3.12789 8.20771Z"
      fill="currentColor"
    />
  </Icon>
);
